import { Button, HookedForm, InputField } from '@app/components';
import { Link } from 'react-router-dom';
import Logo from '@app/assets/vertical-logo.svg?react';
import BackIcon from '@app/assets/icons/back.svg?react';
import LockPassword from '@app/assets/images/lock-password.svg?react';
import { useForgotPasswordPage } from './ForgotPassword.hooks';

export const ForgotPassword = () => {
  const {
    submitForgotPassword,
    emailSent,
    forgotPassordForm,
    navigate,
    userEmail,
    resendLink,
    disableResend,
    resendSecondsLeft,
    errorMessage,
  } = useForgotPasswordPage();

  return (
    <div className="flex items-center justify-center flex-col min-h-screen py-6">
      <Logo width={139} height={110} className="mb-auto" />
      <div className="bg-white text-center space-y-6 rounded-lg max-w-[510px] px-10 pt-10 pb-6 shadow-sm">
        {emailSent ? (
          <>
            <div className="flex items-center text-left w-full">
              <Button
                kind="tertiary"
                className="min-w-fit !w-fit text-[#6B7280]"
                leftNode={<BackIcon />}
                onClick={() => window.location.reload()}
              >
                Back to Forgot Password
              </Button>
            </div>
            <div className="flex items-center justify-center">
              <LockPassword width={140} height={140} />
            </div>
            <h2 className="font-bold text-3xl">Password reset link sent to</h2>
            <p className="text-brand-darkBlue2">{userEmail}</p>
            <p className="text-base-coolGray">
            If you don’t see it in a couple of minutes, check you entered the correct email and check your spam folder.
            </p>
            {disableResend ? (
              <p className="w-full text-center text-base-coolGray mb-2">
                Resend link ({Math.floor(resendSecondsLeft / 60)}:{
                  String(resendSecondsLeft % 60).padStart(2, '0')
                })
              </p>
            ) : (
              <Button
                kind="tertiary"
                className="w-full text-[#52B6FE] font-bold"
                onClick={resendLink}
              >
                Resend link
              </Button>
            )}
            <Button onClick={() => navigate('/login')} className="w-full">
              Return to Log In
            </Button>
          </>
        ) : (
          <>
            <div className="space-y-2">
              <h2 className="font-bold text-2xl text-[#1F2937]">Forgot your password?</h2>
              <p className="text-sm text-[#6B7280]">
                Enter the email associated with your account, and we&apos;ll send
                you a link to reset your password.
              </p>
            </div>

            {errorMessage && (
              <div className="bg-system-errorLight p-2 rounded-lg text-system-error font-medium">
                <p>{errorMessage}</p>
              </div>
            )}

            <HookedForm
              formHook={forgotPassordForm}
              onSubmit={submitForgotPassword}
              className="space-y-4"
            >
              <div className="space-y-2 text-left">
                <label className="block text-sm font-medium text-[#374151]">
                  Email
                </label>
                <InputField 
                  name="email" 
                  type="email" 
                  placeholder="e.g. user@example.com"
                  className="w-full px-3 py-2 border border-[#D1D5DB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3B82F6] focus:border-transparent"
                />
              </div>

              <Button className="w-full">Send Reset Link</Button>
            </HookedForm>
          </>
        )}
      </div>
      <p className="mt-auto text-base-coolGray">
        Remember password?{' '}
        <Link to="/login" className="text-brand-baseBlue font-bold">
         Log In
        </Link>
      </p>
    </div>
  );
};
